import { SafeHydrate } from "@/SafeHydrate";
import { Calendar, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroSection() {
  return <section data-section-id="260452" id="מטפל-סיעודי-במודיעין-פתרון-מיידי" className="relative w-full min-h-[80vh] flex items-center py-24 overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_modiin_home_visit.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_modiin_home_visit.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_modiin_home_visit.png-wvc-sizes" alt="מטפל סיעודי במודיעין" className="w-full h-full object-cover object-center" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/80 to-background/40" />
      </div>

      {}
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl">
          {}
          <div className="mb-6">
            <span className="inline-block py-1 px-3 rounded-md bg-accent text-accent-foreground font-bold text-xs md:text-sm tracking-widest uppercase border border-border backdrop-blur-sm">
              שירות מיידי במודיעין והסביבה
            </span>
          </div>

          {}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6 font-default drop-shadow-md">
            מטפל סיעודי במודיעין תוך 5 שעות
          </h1>

          {}
          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl font-default leading-relaxed drop-shadow">
            זקוקים לעזרה דחופה? אנו מספקים <Link to="/CaregiverServicePagesPage" className="text-primary font-semibold underline">מטפל סיעודי בבית</Link> או <Link to="/CaregiverServicePagesPage2" className="text-primary font-semibold underline">השגחה בבית חולים</Link> בפריסה רחבה במודיעין. פתרון מקצועי, אנושי ומהיר לכל צורך סיעודי.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base h-14 px-8 shadow-lg rounded-md">
              <Link to="tel:0500000000">
                <Phone className="mr-2 h-5 w-5" />
                חייגו עכשיו לייעוץ
              </Link>
            </Button>
            
            <Button asChild size="lg" variant="outline" className="bg-card/50 border-border text-foreground hover:bg-card/70 hover:text-foreground text-base h-14 px-8 backdrop-blur-md shadow-lg rounded-md">
              <Link to="/ContactPage">
                <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
                תיאום מטפל מיידי
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}